import Header from './Compartido/Header.jsx';
import Footer from './Compartido/Footer.jsx';
import BtnFloating from './Compartido/BtnFloating.jsx';
import Intro from './DescubreTenerife/Intro.jsx';
import News from './DescubreTenerife/News.jsx';
import Scripts from './Compartido/Scripts.jsx';

import '../../../../../resources/css/web/holidayhomescanarias/header.css'
import '../../../../../resources/css/web/holidayhomescanarias/buscador.css'
import '../../../../../resources/css/web/holidayhomescanarias/footer.css'
import '../../../../../resources/css/web/holidayhomescanarias/general.css'
import '../../../../../resources/css/web/holidayhomescanarias/nuestrasvillas.css'
import '../../../../../resources/css/web/holidayhomescanarias/rooms.css'
import '../../../../../resources/css/web/holidayhomescanarias/news.css'
import '../../../../../resources/css/web/holidayhomescanarias/buttons.css'
import '../../../../../resources/css/web/holidayhomescanarias/intro.css'

const ListaBlog = (props) => {
    return (
        <main>
            <Header
                datos={props.websgrupo}
                lang={props.lang}
                idiomas={props.idiomas}
                tipo="inicio"
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
            />
            <Intro
                lang={props.lang}
                ruta={props.ruta}
            />
            <News
                lang={props.lang}
                noticias={props.noticias}
                ruta={props.ruta}
            />
            <Footer
                lang={props.lang}
                config={props.config}
            />
            <BtnFloating />

            <Scripts />
        </main>
    );
}

export default ListaBlog;

